@if (!(loading | async)) {
  <layout-sidebar>
    <div class="main">
      <div class="report-claim"><router-outlet></router-outlet></div>
    </div>
    <aside class="main-aside">
      <links-agents-sidebar [quickLinksList]="quickLinksList"></links-agents-sidebar>
    </aside>
  </layout-sidebar>
}
